// extracted by mini-css-extract-plugin
module.exports = {"success":"Success_success__1Rqla","codeButton":"Success_codeButton__25i8W","Logo":"Success_Logo__3-XDO"};